export const pathHomeLeadDetail = "lead-detail";
export const pathHomeReleaseNotes = "release-notes";
export const pathHomeInventoryList = "inventory-list";
export const pathHomeBulkUpload = "bulk-upload";
